export const isFunction = (value: any): value is Function => typeof value === 'function'; // eslint-disable-line

export const isNonNullable = <T>(value: T | null | undefined): value is NonNullable<T> => {
    return value !== null && value !== undefined;
};

export const unifyNullable = <T>(value: T | null | undefined): T | undefined => {
    return value ?? undefined;
};

export function assert(condition: unknown, message: string): asserts condition {
    if (condition) {
        return;
    }

    throw new Error(`Assert failed: ${message}`);
}

export const assertExhaustedSwitch = (switchCase: never) => {
    console.error(new Error(`Unhandled switch case: ${JSON.stringify(switchCase)}`));
};
